import { useEffect, useState } from "react";

export interface UseNativeFormSubmitReturn {
  isSubmitting: boolean;
  markSubmitting: () => void;
}

/**
 * Tracks a form that posts natively (a full page navigation, not XHR), so its
 * button can show a loading state while the browser waits for the response.
 *
 * Coming back with the browser's Back button restores the page from the
 * bfcache mid-submit; this resets then, or the button stays stuck loading.
 */
const useNativeFormSubmit = (): UseNativeFormSubmitReturn => {
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  useEffect(() => {
    const onPageShow = (event: PageTransitionEvent) => {
      if (event.persisted) setIsSubmitting(false);
    };
    window.addEventListener("pageshow", onPageShow);
    return () => window.removeEventListener("pageshow", onPageShow);
  }, []);

  return { isSubmitting, markSubmitting: () => setIsSubmitting(true) };
};

export default useNativeFormSubmit;
